'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoUnlocked = function IoUnlocked(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm6.7 37.5c-0.9 0-1.7-0.8-1.7-1.7v-16.6c0-0.9 0.8-1.7 1.7-1.7h1.7v-2.4c0-3.3 1.4-6.8 3.4-9s5-3.6 8.2-3.6c3.2 0 6.2 1.4 8.2 3.6 1.6 1.6 2.6 4 3.1 6.4h-4.2c-0.4-1.4-1-2.7-1.9-3.7v0c-1.4-1.5-3.2-2.3-5.2-2.3-2 0-3.8 0.8-5.2 2.2v0.1c-1.4 1.5-2.2 4.2-2.2 6.3v2.4h20.7c0.9 0 1.7 0.8 1.7 1.7v16.6c0 0.9-0.8 1.7-1.7 1.7h-26.6z' })
        )
    );
};

exports.default = IoUnlocked;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/unlocked.js
// module id = 2753
// module chunks = 0